// This file was generated using `pay js:run gql-v1 --type=query --name=RetrieveAccount --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

import type {
  V1QueryOptionsWithoutVariables,
  V1QueryOptions,
  V1QueryReturn,
  V1PermissionToken,
} from '@stripe-internal/data-v1/types';
import {useV1Query} from '@stripe-internal/data-v1';
import {gql} from '@sail/data';

import type {GraphQlDocument, GraphQlFragmentUnion} from '@sail/data';

import type {
  Exact,
  InputMaybe,
  OpenapiGetV1AccountInput,
  V1ContextInput,
} from '@stripe-internal/data-v1/schema/types';
import {stripeAccountFragment} from './stripeAccountFragment';

import type {StripeAccountFragmentData} from './stripeAccountFragment';

const doc = gql`
  query RetrieveAccountQuery(
    $input: OpenapiGetV1AccountInput
    $v1Context: V1ContextInput!
  ) {
    v1Account(input: $input, v1Context: $v1Context) {
      id
      ...StripeAccountFragment
    }
  }

  ${stripeAccountFragment}
`;

export const retrieveAccountQuery: RetrieveAccountQueryDocument = doc;

// Fill these options as needed. Options are documented at
// http://go/sail/apis/data/graphql-usage/the-basics-runtime#operation-options
const retrieveAccountQueryOptions: V1QueryOptionsWithoutVariables<RetrieveAccountQueryDocument> =
  {
    // expectedErrors: [],
    // mutedErrors: [],
    // fetchPolicy: 'cache-first',
    // ...
  };

export default function useRetrieveAccountQuery(
  options: V1QueryOptions<RetrieveAccountQueryDocument> = {},
): V1QueryReturn<RetrieveAccountQueryDocument> {
  return useV1Query(
    retrieveAccountQuery,
    Object.assign({}, retrieveAccountQueryOptions, options),
  );
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type RetrieveAccountQueryVariables = Exact<{
  input?: InputMaybe<OpenapiGetV1AccountInput>;
  v1Context: V1ContextInput;
}>;

export type RetrieveAccountQueryData = {
  readonly __typename: 'Query';
  readonly v1Account: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiAccount'; readonly id: string},
    [StripeAccountFragmentData]
  > | null;
};

const retrieveAccountQueryPermissions = {
  ...stripeAccountFragment.permissions,
} as const;

doc.permissions = retrieveAccountQueryPermissions;

export type RetrieveAccountQueryPermissions = V1PermissionToken<
  typeof retrieveAccountQueryPermissions
>;

export type RetrieveAccountQueryDocument = GraphQlDocument<
  RetrieveAccountQueryData,
  RetrieveAccountQueryVariables,
  RetrieveAccountQueryPermissions
>;
